export default __webpack_public_path__ + "static/media/partypopper.ce7b1d59.png";